import { analytics, auth } from 'FirebaseConfigs';
import { AnalyticsEvent } from 'models/AnalyticsEvent';
import firebase from 'firebase/app';
import React, { useCallback, useContext } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { RunAfterTimer } from './RunAfterTimer';

type Props = {
    children: React.ReactNode
}

const AUTH_USER_CONTEXT = React.createContext<[authUser: firebase.User | null, loading: boolean]>([null, true])

export function useAuthUser() {
    return useContext(AUTH_USER_CONTEXT)
}

export function AuthUserProvider({ children }: Props) {
    const [authUser, loadingAuthUser] = useAuthState(auth)

    const loading = loadingAuthUser

    return (
        <AUTH_USER_CONTEXT.Provider value={[authUser || null, loading]}>
            <RunAfterTimer
                time={5000}
                check={!loading && !authUser}
                run={useCallback(() => {
                    analytics.logEvent(AnalyticsEvent.MISSING_AUTH_USER, {
                        authUserId: authUser?.uid,
                    })
                }, [authUser])} />
            {children}
        </AUTH_USER_CONTEXT.Provider>
    )
}